import React, { FC, useState, MouseEvent } from 'react';
import { Routes } from '../../../utils';
import { useMutation } from '@apollo/client/react';
import { CombinedGraphQLErrors } from '@apollo/client';
import { Query } from '../../_common';
import {
    GET_CONVERSATION_BY_ID,
    GET_CONVERSATION_BY_DRIVER_ID_WITH_FILTER,
    GET_ALL_DRIVERS_BY_MESSAGE,
} from '../../../graphql/client/queries';
import { SEND_MESSAGE_TO_CONVERSATION, UPDATE_LAST_MESSAGE_AS_READ } from '../../../graphql/client/mutations';

import { Error, Loading } from '../../_common';
import moment from 'moment';
import { useStoreContext } from '../../App/StoreProvider';
import DriverConversationMessageList from '../DriverConversationMessageList';
import NotificationDetails from '../NotificationDetails';
import { useParams } from 'react-router-dom';

interface LooseObject {
    [key: string]: any;
}

const PAGE_SIZE = 50;

interface MessageDetailProps {
    match: any;
    history: any;
    refetchQuery: boolean;
    setRefetchQuery: any;
    markAllAsReadHander: () => void;
    setIsFetching: React.Dispatch<React.SetStateAction<boolean>>;
}

const MessagesDetail: FC<MessageDetailProps> = ({
    match,
    history,
    refetchQuery,
    setRefetchQuery,
    markAllAsReadHander,
    setIsFetching,
}: MessageDetailProps): React.ReactElement => {
    const [{ auth }] = useStoreContext();
    const [state] = useStoreContext();
    const {
        messageList: { filters, searchPhrase, dateFilter },
    } = state;

    // const abortController = new AbortController();
    // const context = {
    //     fetchOptions: {
    //         signal: abortController.signal,
    //     },
    // };
    // const abortRequest = (): void => {
    //     abortController.abort();
    // };

    // const conversationId = match.params.conversationId;
    //const conversationId = match.params.messageId;
    const {messageId} = useParams();
    const messageIdVal:any = messageId;
    const conversationId = messageIdVal;
    let isConversation = false;
    // logic to get conversationId
    if (isNaN(Number(conversationId))) {
        isConversation = true;
    }

    const conversationByIdVariable ={
        input: {
            dateTo: filters.toDate,
            dateFrom: filters.fromDate,
            id: conversationId,
            date: '',
            filter: dateFilter,
            pageSize: PAGE_SIZE,
            messageType: 'messages',
            searchString: searchPhrase,
        },
        offset: 0,
    };

    const conversationByDriverIdVariable ={
        input: {
            dateTo: filters.toDate,
            dateFrom: filters.fromDate,
            messageType: 'messages',
            pageSize: PAGE_SIZE,
            driverId: parseInt(conversationId),
            searchKeyword: searchPhrase,
        },
        offset: 0,
    }

    const [messageText, setMessageText] = useState<string>('');
    const [messageType, setMessageType] = useState<string>('Regular');
    // const [conversationName, setConversationName] = useState<string>('');
    const [messageConversationId, setMessageConversationId] = useState<string | undefined>();
    // const [messageDriverId, setMessageDriverId] = useState<number>();
    const [isGrupal, setIsGrupal] = useState<boolean>(false);
    const [conversationName, setConversationName] = useState<string | null>(null);
    const [buttonDisable, setButtonDisable] = useState(false);

    const messageCreateVariable = {
        conversationName: null,
        isFromDriver: false,
        isGrupal: false,
        message: {
            creationDate: moment.utc().format(),
            bodyMessage: messageText,
            messageType,
        },
        userId: parseInt(auth.user.profile.id),
    };

    const driverDataSring = localStorage.getItem('driverData_' + messageIdVal);
    let driverName = '';
    let driverCellNo = '';
    if (driverDataSring) {
        const driverData = JSON.parse(driverDataSring);
        
        if (driverData.isGroupAl) {
            messageCreateVariable['isGrupal'] = true;
            messageCreateVariable['conversationName'] = driverData.name;
            messageCreateVariable['conversationId'] = conversationId;
        } else {
            messageCreateVariable['driverIdList'] = [driverData.driver.resultId];
            messageCreateVariable['driverId'] = driverData.driver.resultId;
            messageCreateVariable['conversationId'] = driverData.driver.conversationId;
            driverName = driverData.name;
            driverCellNo = driverData.cellPhone;
        }
    }

    // if (!isGrupal) {
    //     messageCreateVariable['driverIdList'] = [1];
    //     messageCreateVariable['driverId'] = 1;
    // }

    const messageChangetHandler = (event: React.FormEvent<HTMLInputElement>) => {
        event.persist();
        setMessageText(event.currentTarget.value);
    };

    const [updateLastMessageAsRead, { loading: mutationLoad }] = useMutation<LooseObject>(UPDATE_LAST_MESSAGE_AS_READ, {
        onCompleted: data => {},
        refetchQueries: [
            {
                query: GET_CONVERSATION_BY_DRIVER_ID_WITH_FILTER,
                variables: conversationByDriverIdVariable,
            },
            {
                query: GET_CONVERSATION_BY_ID,
                variables: conversationByIdVariable,
            },
        ],
        onError: (e) => {
            if (CombinedGraphQLErrors.is(e)) {
                console.log('GraphQL Error', e.errors);
            } else {
                console.log('Error', e.message);
            }
        },
    });

    const markAsReadHandler = async (conversationId, messageId, id) => {
        await updateLastMessageAsRead({
            variables: {
                input: {
                    conversationId,
                    messageId,
                    id,
                    markMessageAsUnRead: true,
                },
            },
        });

        setRefetchQuery(true);
    };

    const markAsUnReadHandler = async (conversationId, messageId, id) => {
        await updateLastMessageAsRead({
            variables: {
                input: {
                    conversationId,
                    messageId,
                    id,
                    markMessageAsUnRead: false,
                },
            },
        });
        setRefetchQuery(true);
    };

    const [sendMessageToConversation, { loading: mutationLoading }] = useMutation<LooseObject>(
        SEND_MESSAGE_TO_CONVERSATION,
        {
            onCompleted: data => {
                setMessageText('');
                setMessageType('Regular');
                // let driverDataSring = localStorage.getItem('driverData');
                // if (driverDataSring) {
                //     let driverData = JSON.parse(driverDataSring);
                //     if (driverData.driver.conversationId == null) {
                //         driverData.driver.conversationId = data.sendMessageToConversation.conversatonId;
                //         localStorage.setItem('driverData', JSON.stringify(driverData));
                //     }
                // }
                // need to mark this message as read
                const { conversationId, messageId, messageUserId } = data.sendMessageToConversation;
                markAsReadHandler(conversationId, messageId, messageUserId);
            },
            refetchQueries: isConversation
                ? [
                      {
                          query: GET_CONVERSATION_BY_ID,
                          variables: conversationByIdVariable,
                      },
                  ]
                : [
                      {
                          query: GET_CONVERSATION_BY_DRIVER_ID_WITH_FILTER,
                          variables: conversationByDriverIdVariable,
                      },
                  ],

            onError: (e) => {
            if (CombinedGraphQLErrors.is(e)) {
                console.log('GraphQL Error', e.errors);
            } else {
                console.log('Error', e.message);
            }
        },
        },
    );

    const sendMessageHandler = async (event: any) => {
        if (messageText.length == 0) {
            return false;
        }
        setButtonDisable(true);
        await sendMessageToConversation({
            variables: { input: messageCreateVariable },
        });
        setButtonDisable(false);
    };

    const changeSmsHandler = () => {
        setMessageType(prevMessageType => (prevMessageType == 'Regular' ? 'Sms' : 'Regular'));
    };

    

    return (
        <>
            <div className="Driver-Conversation-Section">
                {isConversation ? (
                    <Query<LooseObject>
                        query={GET_CONVERSATION_BY_ID}
                        variables={conversationByIdVariable}
                        fetchPolicy="network-only"
                        // nextFetchPolicy="cache-first"
                    >
                        {({
                            error,
                            data,
                            loading,
                            fetchMore,
                            refetch,
                            networkStatus
                        }): React.ReactElement | null => {
                           
                            if (error) {
                                return <Error error={error} />;
                            }
                            if (loading) {
                                return <Loading />;
                            }
                            const allConversation: LooseObject[] = [];
                            if (data && data.getConversationById && data.getConversationById.length !== 0) {
                                data.getConversationById.forEach((element: LooseObject | null): void => {
                                    if (element !== null) {
                                        allConversation.push(element);
                                    }
                                });
                            }
                            
                            // if (allConversation.find(conversation => conversation.isGrupal)) {
                            //     setIsGrupal(true);
                            //     setConversationName(allConversation[0].conversationName);
                            // }
                            const offset =
                                data && data.getConversationById ? data.getConversationById.length / PAGE_SIZE : 0;

                            let isEndOfResults = false;
                            if (
                                offset % 1 !== 0 ||
                                (!isEndOfResults &&
                                    data &&
                                    data.getConversationById &&
                                    data.getConversationById.length < PAGE_SIZE)
                            ) {
                                isEndOfResults = true;
                            }

                            return (
                                <>
                                    {allConversation.length > 0 ? (
                                        <DriverConversationMessageList
                                            conversations={allConversation}
                                            refetch={refetch}
                                            isLoading={loading}
                                            isEndOfResults={isEndOfResults}
                                            history={history}
                                            onLoadMore={() =>
                                                fetchMore({
                                                    variables: {
                                                        offset,
                                                    },
                                                    updateQuery: (prev, { fetchMoreResult }) => {
                                                        if (
                                                            prev &&
                                                            fetchMoreResult &&
                                                            prev.getConversationById &&
                                                            fetchMoreResult.getConversationById
                                                        ) {
                                                            return Object.assign({}, prev, {
                                                                getConversationById: [
                                                                    ...prev.getConversationById,
                                                                    ...fetchMoreResult.getConversationById,
                                                                ],
                                                            });
                                                        } else {
                                                            return prev;
                                                        }
                                                    },
                                                })
                                            }
                                            markAsReadHandler={markAsReadHandler}
                                            markAsUnReadHandler={markAsUnReadHandler}
                                        />
                                    ) : (
                                        <div className="Message-Conversation no-conversation my-auto text-center justify-content-center align-self-center">
                                            <h5>No Conversation Found!!</h5>
                                        </div>
                                    )}
                                </>
                            );
                        }}
                    </Query>
                ) : (
                    <Query<LooseObject>
                        query={GET_CONVERSATION_BY_DRIVER_ID_WITH_FILTER}
                        variables={conversationByDriverIdVariable}
                        fetchPolicy="network-only"
                        // nextFetchPolicy="cache-first"
                        pollInterval={120000}
                    >
                        {({
                            error,
                            data,
                            loading,
                            fetchMore,
                            refetch,
                        }): React.ReactElement | null => {


                            React.useEffect(()=>{
                                
                                if (refetchQuery) {
                                    refetch();
                                    setRefetchQuery(false);
                                }
                            },[refetchQuery]);
                           

                            if (error) {
                                return <Error error={error} />;
                            }
                            if (loading) {
                                return <Loading />;
                            }
                           

                            const allConversation: LooseObject[] = [];
                            if (
                                data &&
                                data.getConversationByDriverIdWithFilter &&
                                data.getConversationByDriverIdWithFilter.length !== 0
                            ) {
                                data.getConversationByDriverIdWithFilter.forEach(
                                    (element: LooseObject | null): void => {
                                        if (element !== null) {
                                            allConversation.push(element);
                                        }
                                    },
                                );
                                // setMessageConversationId(allConversation[0].conversationId);
                            }

                            const offset =
                                data && data.getConversationByDriverIdWithFilter
                                    ? data.getConversationByDriverIdWithFilter.length / PAGE_SIZE
                                    : 0;

                            let isEndOfResults = false;
                            if (
                                offset % 1 !== 0 ||
                                (!isEndOfResults &&
                                    data &&
                                    data.getConversationByDriverIdWithFilter &&
                                    data.getConversationByDriverIdWithFilter.length < PAGE_SIZE)
                            ) {
                                isEndOfResults = true;
                            }

                            return (
                                <>
                                    <div className="Row my-auto Driver-Conversation-Header justify-content-between">
                                        <div className="pl-0 pr-0 my-auto">
                                            <div className="title">{driverName}</div>
                                            {driverCellNo && <div className="cellPhone">{driverCellNo}</div>}
                                        </div>
                                        <div className="my-auto">
                                            <button className="greenbtn float-right" onClick={markAllAsReadHander}>
                                                Mark All As Read
                                            </button>
                                        </div>
                                    </div>
                                    {allConversation.length > 0 ? (
                                        <DriverConversationMessageList
                                            conversations={allConversation}
                                            refetch={refetch}
                                            isLoading={loading}
                                            isEndOfResults={isEndOfResults}
                                            history={history}
                                            onLoadMore={() =>
                                                fetchMore({
                                                    variables: {
                                                        offset,
                                                    },
                                                    updateQuery: (prev, { fetchMoreResult }) => {
                                                        if (
                                                            prev &&
                                                            fetchMoreResult &&
                                                            prev.getConversationByDriverIdWithFilter &&
                                                            fetchMoreResult.getConversationByDriverIdWithFilter
                                                        ) {
                                                            return Object.assign({}, prev, {
                                                                getConversationByDriverIdWithFilter: [
                                                                    ...prev.getConversationByDriverIdWithFilter,
                                                                    ...fetchMoreResult.getConversationByDriverIdWithFilter,
                                                                ],
                                                            });
                                                        } else {
                                                            return prev;
                                                        }
                                                    },
                                                })
                                            }
                                            markAsReadHandler={markAsReadHandler}
                                            markAsUnReadHandler={markAsUnReadHandler}
                                        />
                                    ) : (
                                        <div className="Message-Conversation no-conversation my-auto text-center justify-content-center align-self-center">
                                            <h5>No Conversation Found!!</h5>
                                        </div>
                                    )}
                                </>
                            );
                        }}
                    </Query>
                )}
                <div className="Message-Conversation-Create">
                    <div className="row">
                        <div className="col-md-9 pr-0 custom-input-send">
                            <div className="SearchBar-Container">
                                <input
                                    id="textSearch"
                                    type="text"
                                    placeholder="Message..."
                                    className="SearchBar-Input"
                                    value={messageText}
                                    onChange={messageChangetHandler}
                                    autoComplete="off"
                                    required={true}
                                    onKeyPress={event => {
                                        if (event.key === 'Enter') {
                                            sendMessageHandler(event);
                                        }
                                    }}
                                />
                            </div>
                        </div>
                        <div className="col-md-3 pl-0 custom-button-send">
                            <div className="actions p-2">
                                <span className="sms">
                                    <input
                                        type="checkbox"
                                        checked={messageType == 'Sms' ? true : false}
                                        onChange={changeSmsHandler}
                                    />{' '}
                                    SMS
                                </span>

                                <button className="float-right" onClick={sendMessageHandler} disabled={buttonDisable}>
                                    Send
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <div className="Notification-List-Section">
                <div className="Message-Conversation no-conversation my-auto text-center justify-content-center align-self-center">
                    <h5>Notification Coming Soon!!</h5>
                </div>
            </div> */}
            <NotificationDetails history={history} match={match} setIsFetching={setIsFetching} />
        </>
    );
};
export default MessagesDetail;

